import React from "react";
import { cn } from "../../lib/utils";
import { Tooltip } from "../ui/tooltip";

interface ConfidenceBadgeProps {
  responseConfidence: number;
  size?: "sm" | "md";
  showLabel?: boolean;
}

function getConfidenceColor(confidence: number) {
  if (confidence >= 0.95) return { text: "text-green-700 dark:text-green-400", bg: "bg-green-100 dark:bg-green-900/30", border: "border-green-200 dark:border-green-800" };
  if (confidence >= 0.85) return { text: "text-yellow-700 dark:text-yellow-400", bg: "bg-yellow-100 dark:bg-yellow-900/30", border: "border-yellow-200 dark:border-yellow-800" };
  return { text: "text-red-700 dark:text-red-400", bg: "bg-red-100 dark:bg-red-900/30", border: "border-red-200 dark:border-red-800" };
}

const ConfidenceBadge: React.FC<ConfidenceBadgeProps> = ({
  responseConfidence,
  size = "sm",
  showLabel = false,
}) => {
  const pct = Math.round(responseConfidence * 100);
  const colors = getConfidenceColor(responseConfidence);

  const badge = (
    <span
      className={cn(
        "inline-flex items-center rounded-full border font-medium",
        colors.bg,
        colors.text,
        colors.border,
        size === "sm" ? "px-2 py-0.5 text-xs" : "px-2.5 py-0.5 text-sm"
      )}
    >
      {showLabel && "Confidence: "}
      {pct}%
    </span>
  );

  return (
    <Tooltip content={`${pct}% response confidence (geometric mean of token probabilities)`}>
      {badge}
    </Tooltip>
  );
};

export default ConfidenceBadge;
